export function validator(entry, validate) {
	const notEmpty = "<br>không được bỏ trống";
	for (let key in validate) {
		if (typeof entry[key] == "boolean") {
			continue;
		} else if (typeof entry[key] == "number") {
			if (entry[key] <= 0) {
				this.$swal({
					icon: "error",
					type: "error",
					title: `${validate[key]} ${notEmpty}`,
				});
				return false;
			}
			continue;
		} else if (typeof entry[key] == "string") {
			if (
				entry[key].trim().length < 1 ||
				entry[key] == null ||
				entry[key] == ""
			) {
				this.$swal({
					icon: "error",
					type: "error",
					title: `${validate[key]} ${notEmpty}`,
				});
				return false;
			}
		} else if (Array.isArray(entry[key])) {
			if (entry[key] == null || entry[key].length == 0) {
				this.$swal({
					icon: "error",
					type: "error",
					title: `${validate[key]} ${notEmpty}`,
				});
				return false;
			}
		} else if (typeof entry[key] == "object") {
			if (entry[key] == null || Object.keys(entry[key]).length == 0) {
				this.$swal({
					icon: "error",
					type: "error",
					title: `${validate[key]} ${notEmpty}`,
				});
				return false;
			}
		} else {
			if (!entry[key]) {
				this.$swal({
					icon: "error",
					type: "error",
					title: `${validate[key]} ${notEmpty}`,
				});
				return false;
			}
		}
	}
	return true;
}
